import moment from "moment";
import { debounce } from "lodash";
import { store } from "@store";
import {
  BookingAuditSearch_Get,
  BookingAuditSearchItemFragment,
  BookingAuditSearch_SetApprove as setApprove,
  BookingAuditSearch_SetComment as setComment
} from "@graphql";
import { hiddenFilterFields } from "./utils";
import { BookingSearchStore } from "../BookingSearchStore";

export class BookingAuditSearchStore extends BookingSearchStore<BookingAuditSearchItemFragment> {
  updateComment: (bookingId: string, comment: string) => void;

  constructor() {
    super(BookingAuditSearch_Get);

    // set initial dates in case dates haven't been modified previously
    if (
      !this.filterManager.isFilterDirty("from") &&
      !this.filterManager.isFilterDirty("to")
    ) {
      const { from, to } = getInitialDates();
      from && this.filterManager.updateFilter({ from }, false, true);
      to && this.filterManager.updateFilter({ to }, false, true);
    }
    this.updateComment = debounce(this._updateComment, 400);
    this.filterManager.hideFields(hiddenFilterFields);

    (window as any).bookingAuditSearchStore = this;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  async fetch(opts?: { skip: number; limit: number }) {
    return await super.fetch(opts);
  }

  setBookingAudit = async (bookingId: string, approved: boolean) => {
    return setApprove.func({ approved, bookingId }).catch((err) => {
      store().snackbars.error(`Cannot update audit\nReason: ${err}`);
    });
  };

  _updateComment = (bookingId: string, value: string) => {
    setComment
      .func({ bookingId, comment: value })
      .catch((e) => store().snackbars.error(`Could not update comment \nReason: ${e}`));
  };
}

function getInitialDates() {
  return {
    from: store().user.inTeam("Ekonomi")
      ? moment().startOf("day").subtract(2, "months").toDate()
      : null,
    to: moment().isoWeek(52).endOf("isoWeek").toDate()
  };
}
